import React from 'react';
import { CheckCircle, Download } from 'lucide-react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function IncludesSection() {
  const items = ['Plan de acción rápido para cada síntoma', 'Recetas naturales complementarias paso a paso', 'Tabla comparativa de síntomas para identificar qué tiene tu hijo', 'Checklist de apoyo en casa', 'Acceso inmediato en PDF — descarga al instante'];
  const scrollToPricing = () => {
    const element = document.getElementById('pricing-cta');
    if (element) element.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 bg-white" data-id="element-192">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-193">
        <div className="text-center mb-12" data-id="element-194">
          <h2 className="text-3xl md:text-4xl font-bold text-forest mb-4" data-id="element-195">
            ¿Qué incluye tu guía?
          </h2>
          <p className="text-forest/70" data-id="element-196">
            Todo lo que necesitas para sentirte preparada
          </p>
        </div>

        <div className="bg-cream rounded-3xl p-8 md:p-12 shadow-lg shadow-sage/5 border border-sage/10" data-id="element-197">
          <ul className="space-y-6" data-id="element-198">
            {items.map((item, idx) => <motion.li key={idx} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="flex items-start gap-4" data-id="element-199">
                <CheckCircle className="h-6 w-6 text-terracotta flex-shrink-0 mt-0.5" data-id="element-200" />
                <span className="text-lg text-forest/90" data-id="element-201">{item}</span>
              </motion.li>)}
          </ul>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} className="mt-10 pt-8 border-t border-sage/10 flex flex-col items-center" data-id="element-202">
            <Button variant="primary" size="lg" onClick={scrollToPricing} className="w-full md:w-auto" data-id="element-203">
              Obtener PequeSalud Natural — $6.39
            </Button>
            <div className="flex items-center gap-2 mt-4 text-sm text-forest/60" data-id="element-204">
              <Download className="h-4 w-4" data-id="element-205" />
              <span data-id="element-206">Descarga digital inmediata</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}